import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useRecoilValue } from 'recoil';

import { Theme } from '@constants';
import { anfState } from '@store';

import { ControlsContainer } from './controls/ControlsContainer';
import { Video } from './Video';
import { VideoLoadingIndicator } from './VideoLoadingIndicator';

import { addLiveRampSegmentAttribution } from '../../helpers/addLiveRampSegmentAttribution';
import { getLiveRamp } from '../../hooks/useLiveRamp/helpers/getLiveRamp';

export const VideoPlayer = ({
  adData,
  data,
  error,
  isLoading,
  isScreenFocused,
  isFullscreen,
  nextFocusUp,
  width,
  height,
  reference,
  translation,
  onVideoEnd,
  onVideoProgress,
  vodPlaylistReference,
}) => {
  const avails = adData?.avails;
  const ads = avails && avails.length > 0 ? avails[0] : null;

  const { data: anfAlerts } = useRecoilValue(anfState);
  const anfSelected = anfAlerts?.find(anf => anf.selected);
  const sourceVideo = anfSelected?.url ?? data?.url;

  const liveRamp = getLiveRamp();
  const source = liveRamp?.envelope ? addLiveRampSegmentAttribution(sourceVideo, liveRamp.envelope) : sourceVideo;

  return (
    <View style={styles.contentWrapper}>
      {isLoading || error || !data || !source ? (
        <>
          <VideoLoadingIndicator hasError={error || (!isLoading && !source)} height={height} width={width} />
          {isFullscreen &&
            data?.isLive && ( // Show controls for switching live feeds if there is an error
              <ControlsContainer
                controlsOnRef={vodPlaylistReference}
                data={data}
                isLive={data.isLive}
                nextFocusUp={nextFocusUp}
                preventButtons={[]}
                onControl={() => null}
              />
            )}
        </>
      ) : (
        <Video
          ads={ads}
          data={{ ...data, anf: anfAlerts, isANF: Boolean(anfSelected?.url) }}
          height={height}
          isFullscreen={isFullscreen}
          nextFocusUp={nextFocusUp}
          ref={reference}
          source={source}
          stopped={!isScreenFocused}
          translation={translation}
          vodPlaylistReference={vodPlaylistReference}
          width={width}
          onVideoEnd={onVideoEnd}
          onVideoProgress={onVideoProgress}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  contentWrapper: {
    flex: 1,
    justifyContent: 'center',
  },
  errorText: {
    color: Theme.white,
  },
  errorWrapper: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
  videoLoadingIndicator: {
    bottom: 0,
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
  },
});
